import { IRLSidepanelPreviewItemComparer, RLDefaultPreviewItemComparer } from "./sidepanel-preview-item-comparers";

// -------- rl-sidepanel ----------------------------------------------------------

export interface IRLSidepanelScope extends ng.IScope {
    previewEntities: any[];
    selectedEntity: any;
    previewItemComparer: IRLSidepanelPreviewItemComparer;
    editMode: boolean;
    showKeyart: boolean;
    hasKeyart: boolean;
}

RLSidepanel.$inject = ["$parse"];

export function RLSidepanel($parse: ng.IParseService): ng.IDirective {
    return {
        restrict: 'EA',
        template: require("/assets/app/templates/sidepanel.html"),
        scope: true,
        bindToController: {
            entityId: "@",
            selectedEntity: "=?",
            previewEntities: "=?",
            previewItemComparer: "=?",
            showKeyart: "=?",
            hasKeyart: "=?",
            editMode: "=?"
        },
        controller: RLSidepanelController,
        controllerAs: 'spVM',
        transclude: true,
        link: (scope: IRLSidepanelScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any, transclude: ng.ITranscludeFunction) => {
        }
    }
}

export class RLSidepanelController {
    static $inject = ["$window", "$scope", "$element"];

    public isKeyartTabActive: boolean = false;
    public isCommentsTabActive: boolean = true;
    public isHistoryTabActive: boolean = false;
    public isPreviewsTabActive: boolean = false;

    public entityId: string;
    public showPreviewTab: boolean = false;

    public selectedEntity: any;
    public previewEntities: any[] = [];

    public previewItemComparer: IRLSidepanelPreviewItemComparer;

    public editMode: boolean;
    public showKeyart: boolean;
    public hasKeyart: boolean;

    constructor(
        private $window: ng.IWindowService,
        private $scope: IRLSidepanelScope,
        private $element: ng.IAugmentedJQuery) {

        if (!this.previewItemComparer) {
            this.previewItemComparer = new RLDefaultPreviewItemComparer();
        }

        $scope.$watch(() => this.selectedEntity, (newValue: any, oldValue: any) => {
            if (newValue != null && newValue !== oldValue) {
                this.isPreviewsTabActive = true;
            }
        });

        $scope.$watch(() => this.previewEntities, (newValue, oldValue) => {
            this.showPreviewTab = this.ShouldActivatePreviewTab();
            if (newValue != null && oldValue != null && newValue.length > oldValue.length) {
                this.isPreviewsTabActive = true;
            }
        });

        //$scope.$watch(() => this.hasKeyart, (newValue, oldValue) => {
        //    if( (newValue !== oldValue) && ( newValue === true) && this.showKeyart) {
        //        this.isCommentsTabActive = false;
        //        this.isKeyartTabActive = true;
        //    }
        //});

        $scope.$watch(() => this.showPreviewTab, (newValue, oldValue) => {
            if ((newValue !== oldValue) && (newValue === false) && this.isPreviewsTabActive) {
                this.isCommentsTabActive = true;
            }
        });

        this.Init();
    }

    Init() {
        if (this.showKeyart) {
            this.isCommentsTabActive = false;
            this.isKeyartTabActive = true;
        }
        return;
    }

    private ShouldActivatePreviewTab(): boolean {
        return (this.previewEntities != null && this.previewEntities.length > 0);
    }
}


// // TODO: move this somewhere re-usable / usage notes
// $.expr[':'].css = function(obj, index, meta, stack) {
//     var args = meta[3].split(/\s*=\s*/);
//     return $(obj).css(args[0]) == args[1];
// }


